import { useSelector } from 'react-redux'
import { RootState } from 'store'
import { sdk } from 'utils/signer/utils'

export function useLinkSigner() {
  return useSelector<RootState, sdk.JsonRpcSigner | undefined>(
    (state) => state.link.signer
  )
}
export function useLinkConnected() {
  return useSelector<RootState, boolean>((state) => state.link.connected)
}
export function useLinkConnecting() {
  return useSelector<RootState, boolean>((state) => state.link.connecting)
}
